import {
  Autocomplete,
  Checkbox,
  Slider,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Field, useFormikContext } from "formik";
import React, { Fragment } from "react";
import { AutocompleteText } from "../../../../../component/AutoComplete";
import CommonTextField from "../../../../../component/Input";
import DropDownSelect from "../../../../../component/Select";
import { HandleSkeletion } from "../../../../../utils/constants";
import { CustomDiv } from "../../../../chat-bot/style";
import { CommonGrid2 } from "../../../../common-components/StyledComponents";
import { CustomizeSpan, ErrorContent } from "../../../../jobs/style";
import CommonPhoneInput from "../../../../../component/PhoneInput";

export default function ViewBasicInfo({ basicInfoData, isLoading }) {
  const { values, errors, setValues, setFieldValue, handleBlur } =
    useFormikContext();

  return (
    <CommonGrid2 marginTop={"2rem"}>
      <Typography variant="h3">Basic Info</Typography>
      <CommonGrid2
        container
        columnSpacing={3}
        rowSpacing={3}
        marginTop={"1.5rem"}
      >
        {basicInfoData?.map((item, index) => {
          return (
            <CommonGrid2
              item
              size={{
                xs: 12,
                md: 4,
                sm: 6,
              }}
              key={item.title}
              gap={"8px"}
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"flex-start"}
            >
              {isLoading ? (
                <HandleSkeletion height={60} transform="scale(1)" />
              ) : (
                <Fragment>
                  <CommonGrid2
                    display={"flex"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    width={"100%"}
                  >
                    <Tooltip arrow title={item.title} placement="top">
                      <Typography
                        variant="p"
                        color="#344054"
                        fontSize="16px"
                        textOverflow={"ellipsis"}
                        whiteSpace={"nowrap"}
                        overflow={"hidden"}
                      >
                        {item.title}
                        {item.mandatory && (
                          <CustomizeSpan color={"red"}> *</CustomizeSpan>
                        )}
                      </Typography>
                    </Tooltip>
                  </CommonGrid2>
                  {item.component === "input" && (
                    <Field name={item.titleName}>
                      {({ field, form }) => {
                        return (
                          <CommonTextField
                            {...field}
                            placeholder={item?.placeholder}
                            padding="10px"
                            error={Boolean(
                              form.touched[item.titleName] &&
                                form.errors[item.titleName]
                            )}
                            placeholderFontSize={item?.placeholderFontSize}
                            helperText={
                              form.touched[item.titleName] &&
                              form.errors[item.titleName]
                            }
                            value={values[item.titleName]}
                            onChange={(e) => {
                              console.log(
                                e.target.value,
                                "sfksnfskjfnsklflk",
                                item.titleName
                              );
                              setFieldValue(item.titleName, e.target.value);
                            }}
                          />
                        );
                      }}
                    </Field>
                  )}
                  {item.component === "dropDown" && (
                    <Field name={item.titleName}>
                      {({ field, form }) => {
                        return (
                          <DropDownSelect
                            marginTop="0px"
                            title={
                              item?.placeholder ? item?.placeholder : item.title
                            }
                            disabled={item?.disabled}
                            removeAnimation={true}
                            data={form.values[item.dropDownData]}
                            error={Boolean(
                              form.touched[item.titleName] &&
                                form.errors[item.titleName]
                            )}
                            helperText={
                              form.touched[item.titleName] &&
                              form.errors[item.titleName]
                            }
                            value={form.values[item.titleName]}
                            handleChange={(event) =>
                              setFieldValue(item.titleName, event.target.value)
                            }
                          />
                        );
                      }}
                    </Field>
                  )}

                  {item.component === "single-auto-complete" && (
                    <Field name={item.titleName}>
                      {({ field, form }) => {
                        return (
                          <Autocomplete
                            disablePortal
                            getOptionLabel={(option) => option.name}
                            options={values[item.dropDownData]}
                            value={
                              values[item.titleName]
                                ? values[item.dropDownData].find(
                                    (option) =>
                                      option.name === values[item.titleName]
                                  ) || null
                                : null
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={
                                  !values[item.titleName]
                                    ? item.placeholder
                                    : ""
                                }
                                error={Boolean(
                                  form.touched[item.titleName] &&
                                    form.errors[item.titleName]
                                )}
                                helperText={
                                  form.touched[item.titleName] &&
                                  form.errors[item.titleName]
                                }
                              />
                            )}
                            onChange={(event, newValue) => {
                              if (newValue) {
                                form.setFieldValue(
                                  item.titleName,
                                  newValue.name
                                );
                              } else {
                                form.setFieldValue(item.titleName, null);
                              }
                            }}
                            ListboxProps={{
                              id: "sigle-autocomplete-list",
                            }}
                            sx={{
                              "& input": {
                                fontSize: "15px",
                              },
                              "& .MuiInputBase-root": {
                                padding: "5px",
                              },
                              "& fieldset": {
                                border: "1px solid #D0D5DD",
                                borderRadius: "6px",
                              },

                              "& label": {
                                top: "-4px",
                              },
                              "& label.MuiInputLabel-shrink": {
                                top: "0px",
                              },
                              "& .Mui-error": {
                                margin: "2px 0px 0px",
                                fontWeight: 600,
                                color: "#d32f2f",
                              },
                            }}
                          />
                        );
                      }}
                    </Field>
                  )}

                  {item.component === "multi-complete" && (
                    <Field name={item.titleName}>
                      {({ field, form }) => {
                        const selectedValues = Array.isArray(
                          values[item.titleName]
                        )
                          ? values[item.titleName]
                          : [];

                        const options = Array.isArray(values[item.options])
                          ? values[item.options]
                          : [];

                        return (
                          <CustomDiv>
                            <Autocomplete
                              multiple
                              options={options}
                              getOptionLabel={(option) => option.name || ""}
                              value={options.filter((opt) =>
                                selectedValues.some((sel) => sel.id === opt.id)
                              )}
                              onChange={(e, newValue) =>
                                setFieldValue(item.titleName, newValue)
                              }
                              limitTags={2}
                              renderOption={(props, option, { selected }) => {
                                const isChecked = selectedValues.some(
                                  (val) => val.name === option.name || selected
                                );

                                return (
                                  <li
                                    {...props}
                                    style={{ padding: "3px 10px" }}
                                  >
                                    <Checkbox checked={isChecked} />
                                    {option.name || option}
                                  </li>
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder={item.placeholder}
                                  error={errors[item.titleName]}
                                />
                              )}
                              ListboxProps={{
                                id: "custom-autocomplete-list",
                              }}
                              disablePortal
                              disableCloseOnSelect
                              sx={{
                                "& label.MuiInputLabel-sizeMedium": {
                                  top: "-5px !important",
                                },
                                "& label.MuiInputLabel-shrink": {
                                  top: "0px !important",
                                },
                                "& .MuiInputBase-formControl": {
                                  padding: "5px 39px 5px 9px",
                                  gap: "4px",
                                },
                                "& fieldset": {
                                  border: "1px solid #D0D5DD",
                                },
                                "& .MuiAutocomplete-tag": {
                                  gap: "5px",
                                  margin: "0px 3px",
                                  borderRadius: "5px",
                                  fontSize: "12px",
                                  border: "1px solid",
                                  padding: "2px 6px",
                                  background: "rgba(0, 0, 0, 0.08)",
                                },
                              }}
                            />
                            {errors[item.titleName] && (
                              <ErrorContent>
                                {errors[item.titleName]}
                              </ErrorContent>
                            )}
                          </CustomDiv>
                        );
                      }}
                    </Field>
                  )}

                  {item.component === "autoComplete" && (
                    <Field name={item.titleName}>
                      {({ field, form }) => {
                        const handleAutoCompleteChange = (e, newValue) => {
                          if (e?.key === "Backspace" && e.target.value === "") {
                            const updatedValue = [
                              ...(form.values[item.titleName] || []),
                            ];
                            updatedValue.pop();
                            form.setFieldValue(item.titleName, updatedValue);
                          } else {
                            const formattedValues = newValue.map(
                              (item, index) => {
                                if (typeof item === "string") {
                                  return {
                                    content: item,
                                  };
                                }
                                return item;
                              }
                            );

                            form.setFieldValue(item.titleName, formattedValues);
                          }
                        };

                        const handleDelete = (option) => {
                          const updatedValue = form.values[
                            item.titleName
                          ].filter((item, i) => item !== option);
                          form.setFieldValue(item.titleName, updatedValue);
                        };

                        const isError =
                          form.touched[item.titleName] &&
                          form.errors[item.titleName];
                        const helperText = isError
                          ? form.errors[item.titleName]
                          : "";

                        const handleKeyDown = (e) => {
                          const checkData = form?.values[item.titleName];
                          const dataValue = e.target.value;
                          if (e.key === "Tab") {
                            e.preventDefault();

                            if (dataValue !== "") {
                              const data = {
                                content: dataValue,
                              };

                              const formattedValues = [...checkData, data];
                              form.setFieldValue(
                                item.titleName,
                                formattedValues
                              );
                              form.setFieldValue(item.inputValue, "");
                            }
                          }
                        };

                        return (
                          <CustomDiv>
                            <AutocompleteText
                              autoData={{
                                options: [],
                                key: `autocomplete-${index}`,
                                title: "Select Emails",
                                placeholder: item.placeholder,
                                // isDisabled: false,
                                value: values[item.titleName] || "",
                                onDelete: handleDelete,
                                onKeyDown: handleKeyDown,
                                onChange: handleAutoCompleteChange,
                                inputValue: values[item.inputValue],
                                onInputChange: (e, newValue) => {
                                  setFieldValue(item.inputValue, newValue);
                                },
                                isDisabled: item?.disabled,
                                customClass: item.titleName,
                              }}
                              error={isError}
                            />
                            {isError && (
                              <ErrorContent margin="2px 0px 0px">
                                {helperText}
                              </ErrorContent>
                            )}
                          </CustomDiv>
                        );
                      }}
                    </Field>
                  )}
                  {item.component === "slider" && (
                    <Field name={item.titleName}>
                      {({ field, form }) => {
                        return (
                          <Slider
                            min={0}
                            max={5}
                            step={0.1}
                            value={values[item.titleName]}
                            valueLabelDisplay="auto"
                            onChange={(_, newValue) =>
                              setFieldValue(item.titleName, newValue)
                            }
                            sx={{
                              height: "7px",
                              "& .MuiSlider-rail": {
                                backgroundColor: "#d1d2d4",
                              },
                              "& .MuiSlider-thumb": {
                                width: 22,
                                height: 22,
                                backgroundColor: "#fff",
                                border: "2px solid #7F56D9",
                              },
                              "& .MuiSlider-valueLabel": {
                                backgroundColor: "#6941C6",
                                fontSize: "13px",
                                color: "white",
                              },
                            }}
                          />
                        );
                      }}
                    </Field>
                  )}

                  {item.component === "phone-number" && (
                    <Field name={item.titleName}>
                      {({ field, form }) => {
                        const isError = Boolean(
                          form.touched[item.titleName] &&
                            form.errors[item.titleName]
                        );
                        return (
                          <>
                            <CommonPhoneInput
                              placeholder={item?.placeholder}
                              padding="14px 0px 14px 60px"
                              country="us"
                              value={values[item.titleName]}
                              onChange={(e, countryData) => {
                                setFieldValue(item.country, countryData);
                                setFieldValue(item.titleName, e);
                              }}
                            />
                            {isError && (
                              <ErrorContent
                                margin="-2px 0px 0px"
                                className="Mui-error"
                              >
                                {form.errors[item.titleName]}
                              </ErrorContent>
                            )}
                          </>
                        );
                      }}
                    </Field>
                  )}
                </Fragment>
              )}
            </CommonGrid2>
          );
        })}
      </CommonGrid2>
    </CommonGrid2>
  );
}
